<div *ngIf="ldapData && ldapData.length; else noData">
    <div class="hvac-row">
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-ldap-data-details-col">
            <ul class="layer-view-ldap-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.FIRST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].firstName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.LAST_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].lastName | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.EMAIL' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].mail | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.SITE_ACCESS' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].accessRights | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.CAR_LICENCE' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].carLicense | textFallback }}</div>
                </li>
            </ul>
        </div>
        <div class="hvac-col-xs-12 hvac-col-lg-6 layer-view-ldap-data-details-col">
            <ul class="layer-view-ldap-data-detail-list">
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.USER_NAME' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].uid | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.COMPANY_TYPE' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].companyType | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.COMPANY_SERVICES' | translate}}</div>
                    <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ ldapData[0].companyTypes?.join(', ') | textFallback }}</div>
                </li>
                <li class="hvac-row hvac-top-xs">
                    <div class="hvac-col-xs-5 hvac-label">{{ 'USER_ADMIN.LDAP_DATA.LDAP_ATTRIBUTES' | translate}}</div>
                    <div>
                        <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ 'company-type : ' + ldapData[0].companyTypes[0] | textFallback }}</div>
                        <div class="hvac-col-xs layer-view-ldap-data-list-value hvac-non-edit-mode">{{ 'job-title : ' + ldapData[0].jobTitle[0] | textFallback }}</div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
<ng-template #noData>
    <p class="hvac-user-not-found">{{ 'USER_ADMIN.LAYER_VIEW.USER_NOT_FOUND_IN_LDAP' | translate}}</p>
</ng-template>
